import React, { useEffect } from 'react';
import { Row, Col, Avatar, Card, Button, Modal } from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
// import { format } from 'date-fns';
import PropTypes from 'prop-types';
// import { PROFILE_FAMILY_GET, FAMILY_TREE_GET } from './constants';
// import { makeSelectFamily, makeSelectRequestingg, makeSelectProfile } from './selectors';
import '../../css/custom.css';
// import 'antd/dist/antd.css'; // eslint-disable-line
import Profile from '../../Images/Prof.png';
import Tag from '../../Images/Tag.png';
// import Med from '../../Images/Med.png';
import noProfile from '../../Images/noProfile.png';
import './style.css';
import { familyTreeRequest, patientDetailsRequest, profileFamilyRequest, deleteFamilyMember } from './Actions';
import { selectFamilyTreeDetails, selectLoading, selectPatientDetails } from './Selectors';
import { BodyTextHeading, BodyTextKey, BodyTextValue, ButtonText } from '../CommonText';
import { Content } from 'antd/es/layout/layout';
// import { CustomSpin } from '../CommonSpin';
import CustomSpin from '../CommonSpin';
import { useNavigate } from 'react-router-dom';
// import messages from './message';
// import { FormattedMessage } from 'react-intl';
import english from '../../Translations/English.json';
import hindi from '../../Translations/Hindi.json';
import malayalam from '../../Translations/Malayalam.json';
import dayjs from 'dayjs';

const MyFamily = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const family = useSelector(selectFamilyTreeDetails);
    const requesting = useSelector(selectLoading);
    const profiles = useSelector(selectPatientDetails);

    useEffect(() => {
        dispatch(patientDetailsRequest());
        dispatch(familyTreeRequest());
    }, [dispatch]);

    const handleFamilyCardClick = (itemId) => {
        dispatch(profileFamilyRequest(itemId));
    };

    const handleEditFamilyMember = (memberId) => {
        navigate(`/editfamily/${memberId}`);
    };

    const handleDeleteFamilyMember = (itemId) => {
        Modal.confirm({
            title: langdata.DeleteConfirmationTitle,
            content: langdata.DeleteConfirmationMessage,
            okText: langdata.DeleteConfirmationOkText,
            okType: 'danger',
            cancelText: langdata.DeleteConfirmationCancelText,
            onOk: () => {
                console.log(`Delete button clicked for family member with ID: ${itemId}`);
                dispatch(deleteFamilyMember(itemId));
            },
            onCancel: () => {
                console.log('Delete action cancelled');
            },
        });
    };

    const patientId = sessionStorage.getItem('PATIENT_ID');    

    useEffect(() => {
        if (!patientId) {
            Modal.warning({
                title: 'Complete your profile',
                content: 'Please complete your profile details here...',
            });
            navigate('/addprofile');
        }
    },[navigate, patientId]);


    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid === 'en' ? english : langid === 'ma' ? malayalam : langid === 'hin' ? hindi : english;

    const cardItems = family?.data?.map((item) => (
        <Col
            key={item.id}
            xs={24} 
            sm={12} 
            md={8} 
            lg={6} 
            xl={6}
            xxl={4}
            style={{ padding: '8px' }}
        >
            <Card
                onClick={() => handleFamilyCardClick(item.id)}
                hoverable
                className="family-card"
                style={{
                    width: '100%',
                    minHeight: '120px',
                    position: 'relative',
                }}
                bodyStyle={{ 
                    padding: '15px',
                    display: 'flex',
                    alignItems: 'center'
                }}
            >
                {!item.isParent && (
                    <div style={{ 
                        position: 'absolute', 
                        top: '10px', 
                        right: '10px', 
                        zIndex: 1, 
                        display: 'flex', 
                        gap: '8px',
                        background: 'rgba(255, 255, 255, 0.9)',
                        padding: '4px',
                        borderRadius: '4px'
                    }}>
                        <EditOutlined
                            style={{ fontSize: '16px', color: '#1164A6', cursor: 'pointer' }}
                            onClick={(e) => {
                                e.stopPropagation();
                                handleEditFamilyMember(item.id);
                            }}
                        />
                        <DeleteOutlined
                            style={{ fontSize: '16px', color: 'red', cursor: 'pointer' }}
                            onClick={(e) => {
                                e.stopPropagation();
                                handleDeleteFamilyMember(item.id);
                            }}
                        />
                    </div>
                )}
                <Row style={{ width: '100%', alignItems: 'center' }}>
                    <Col xs={8} sm={7} md={7} lg={7} xl={7} xxl={6} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <Avatar
                            style={{
                                width: '60px',
                                height: '60px',
                                borderWidth: 2,
                                borderColor: '#CACACA',
                                borderStyle: 'double',
                            }}
                            src={item.profilephotourl ? item.profilephotourl : noProfile}
                        />
                    </Col>
                    <Col xs={16} sm={17} md={17} lg={17} xl={17} xxl={18} style={{
                        wordWrap: 'break-word',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        paddingLeft: '10px',
                    }}>
                        <div className="family-member-name">{item.firstName}</div>
                        <div className="family-member-relation">
                            {item.isParent ? 'Parent' : item.relationShip}
                        </div>
                    </Col>
                </Row>
            </Card>
        </Col>
    ));

    let profBody = null;

    if (profiles) {
        const item = profiles;
        profBody = (
            <div key={item.id}>
                <Row type="flex" justify="center">
                    <Col
                        xs={{ span: 24 }}
                        md={{ span: 24 }}
                        lg={{ span: 24 }}
                        xl={{ span: 24 }}
                        xxl={{ span: 24 }}
                    >
                        <Row>
                            <Col
                                xs={{ span: 24 }}
                                md={{ span: 22 }}
                                lg={{ span: 22 }}
                                xl={{ span: 24 }}
                                xxl={{ span: 24 }}
                            >
                                <Row>
                                    <Col
                                        xs={{ span: 22, offset: 1 }}
                                        md={{ span: 22, offset: 1 }}
                                        lg={{ span: 10, offset: 1 }}
                                        xl={{ span: 10, offset: 1 }}
                                        xxl={{ span: 10, offset: 1 }}
                                    >
                                        <Card
                                            style={{
                                                marginBottom: '10px',
                                                width: '100%',
                                                marginTop: '20px',
                                                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.18)',
                                                borderRadius: '8px',
                                                paddingBottom: '20px',
                                            }}
                                        >
                                            <Col>
                                                <div style={{ float: 'left' }}>
                                                    <Avatar
                                                        shape="square"
                                                        src={Profile}
                                                        style={{ width: '31px', height: '33px' }}
                                                    />
                                                </div>
                                                <div style={{ fontSize: '21px', marginLeft: '6%', color: '#000000' }}>
                                                    <BodyTextHeading text={`${langdata.PersonalInfo ? langdata.PersonalInfo : 'Personal Info' }`} />
                                                </div>
                                            </Col>
                                            <Row style={{ marginTop: '12px' }}>
                                                <Col>
                                                    <div
                                                        style={{
                                                            color: '#828282',
                                                            fontSize: '16px',
                                                            fontFamily: 'Roboto',
                                                            paddingTop: '14px',
                                                        }}
                                                    >
                                                        <BodyTextKey text={`${langdata.Name ? langdata.Name : 'Name' }`}/>&nbsp;:&nbsp;
                                                        <BodyTextValue text={`${item.firstName} ${item.lastName}`} />
                                                    </div>
                                                    <div
                                                        style={{
                                                            color: '#828282',
                                                            fontSize: '16px',
                                                            fontFamily: 'Roboto',
                                                            paddingTop: '14px',
                                                        }}
                                                    >
                                                        <BodyTextKey text={`${langdata.Gender ? langdata.Gender : 'Gender' }`}/>&nbsp;:&nbsp;
                                                        <BodyTextValue text={item.gender} />
                                                    </div>
                                                    <div
                                                        style={{
                                                            color: '#828282',
                                                            fontSize: '16px',
                                                            fontFamily: 'Roboto',
                                                            paddingTop: '14px',
                                                        }}
                                                    >
                                                        <BodyTextKey text={`${langdata.BloodGroup ? langdata.BloodGroup : 'Blood Group' }`}/>&nbsp;:&nbsp;
                                                        <BodyTextValue text={item.bloodGroup ? item.bloodGroup : 'Not Specified' } />
                                                    </div>
                                                    <div
                                                        style={{
                                                            color: '#828282',
                                                            fontSize: '16px',
                                                            fontFamily: 'Roboto',
                                                            paddingTop: '14px',
                                                        }}
                                                    >
                                                        <BodyTextKey text={`${langdata.DateofBirth ? langdata.DateofBirth : 'Date of Birth' }`}/>&nbsp;:&nbsp;
                                                        <BodyTextValue text={item.dob ? dayjs(item.dob).format('DD-MM-YYYY') : null} />
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Card>
                                    </Col>

                                    <Col
                                        xs={{ span: 22, offset: 1 }}
                                        md={{ span: 22, offset: 1 }}
                                        lg={{ span: 11, offset: 1 }}
                                        xl={{ span: 11, offset: 1 }}
                                        xxl={{ span: 11, offset: 1 }}
                                    >
                                        <Card
                                            style={{
                                                width: '100%',
                                                marginTop: '20px',
                                                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.18)',
                                                borderRadius: '8px',
                                                marginBottom: '10px',
                                                paddingBottom: '20px',
                                            }}
                                        >
                                            <Col>
                                                <div style={{ float: 'left' }}>
                                                    <Avatar
                                                        shape="square"
                                                        src={Tag}
                                                        style={{ width: '20px', height: '30px', marginTop: '10%' }}
                                                    />
                                                </div>
                                                <div style={{ fontSize: '21px', marginLeft: '4%', color: '#000000' }}>
                                                    <BodyTextHeading text={`${langdata.Contact ? langdata.Contact : 'Contact'}`} />
                                                </div>
                                            </Col>
                                            <Row style={{ marginTop: '24px' }}>
                                                <Col>
                                                    <div style={{ color: '#828282', fontSize: '16px', fontFamily: 'Roboto' }}>
                                                        <BodyTextKey text={`${langdata.Email ? langdata.Email : 'Email' }`}/>&nbsp;:&nbsp;
                                                        <BodyTextValue text={item.primaryEmail} />
                                                    </div>
                                                    <div
                                                        style={{
                                                            color: '#828282',
                                                            fontSize: '16px',
                                                            fontFamily: 'Roboto',
                                                            paddingTop: '14px',
                                                        }}
                                                    >
                                                        <BodyTextKey text={`${langdata.Address ? langdata.Address : 'Address' }`}/>&nbsp;:&nbsp;
                                                        <BodyTextValue text={item.address} />
                                                    </div>
                                                    <div
                                                        style={{
                                                            color: '#828282',
                                                            fontSize: '16px',
                                                            fontFamily: 'Roboto',
                                                            paddingTop: '14px',
                                                        }}
                                                    >
                                                        <BodyTextKey text={`${langdata.Phone ? langdata.Phone : 'Phone' }`}/>&nbsp;:&nbsp;
                                                        <BodyTextValue text={item.primaryContact} />
                                                    </div>
                                                    <div
                                                        style={{
                                                            color: '#828282',
                                                            fontSize: '16px',
                                                            fontFamily: 'Roboto',
                                                            paddingTop: '14px',
                                                        }}
                                                    >
                                                        <BodyTextKey text={`${langdata.Countryofresidence ? langdata.Countryofresidence : 'Country of residence' }`}/>&nbsp;:&nbsp;
                                                        <BodyTextValue text={item.residentCountry} />
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Card>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        );
    }

    return (
        <Content className="family-tree-container">
            <Row>
                <Col xs={24} md={24} lg={24} xl={24} xxl={24}>
                    <Row>
                        <Col xs={24} md={24} lg={24} xl={24} xxl={24} className="cards-scroll-container">
                            <Row gutter={[8, 8]}>
                                {cardItems}
                            </Row>
                        </Col>
                    </Row>
                    <Row justify="center" style={{ marginTop: '20px', marginBottom: '20px' }}>
                        <Col xs={24} sm={12} md={8} lg={6} xl={4}>
                            <Button
                                onClick={() => {
                                    navigate('/addfamily');
                                }}
                                style={{
                                    width: '100%',
                                    background: '#1164A6',
                                    color: 'white',
                                    height: '40px',
                                    borderRadius: '4px'
                                }}
                            >
                                <ButtonText text={`${langdata.AddFamily ? langdata.AddFamily : 'Add Family'}`} color='white' />
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
            {profBody}
            <CustomSpin spinning={requesting} />
        </Content>
    );
};

MyFamily.propTypes = {
    history: PropTypes.object,
};

export default MyFamily;